module.exports = __webpack_public_path__ + "img/物业缴费.cee78bb6.png";